import { ReactNode } from 'react';
import { AudioContextProvider } from './contexts/audio/AudioContext';
import { DataContextProvider } from './contexts/data/DataContext';

import { GlobalContextProvider } from './contexts/global/GlobalContext';
import { InventoryContextProvider } from './contexts/inventory/InventoryContext';
import { PuzzleContextProvider } from './contexts/puzzle/PuzzleContext';
import { TextContextProvider } from './contexts/text/TextContext';

const ContextProvider = (props:{children: ReactNode}) => {
	return (	
		<TextContextProvider>
			<AudioContextProvider>
				<DataContextProvider>
					<GlobalContextProvider>
						<InventoryContextProvider>
							<PuzzleContextProvider>
								{props.children}					
							</PuzzleContextProvider>	
						</InventoryContextProvider>
					</GlobalContextProvider>
				</DataContextProvider>
			</AudioContextProvider>
		</TextContextProvider>
	);
};

export default ContextProvider;